import { b64uDecode, b64uEncode } from './base64url';

const encoder = new TextEncoder();

export function utf8(text: string): Uint8Array {
  return encoder.encode(text);
}

export async function sha256(data: Uint8Array): Promise<Uint8Array> {
  return new Uint8Array(await crypto.subtle.digest('SHA-256', data as BufferSource));
}

/**
 * Public key fingerprint — the identifier used in signatures and in the manifest:
 * base64url(SHA-256(decoded key bytes)). The hash is over the DECODED bytes, exactly
 * as `common.yaml` defines `PublicKey.id`.
 */
export async function fingerprintOfKey(keyB64: string): Promise<string> {
  return b64uEncode(await sha256(b64uDecode(keyB64)));
}
